<template>
	<div class="lunbo-wrap">
		<video
			v-if="videoSrc"
			class="bgvideo"
			:src="videoSrc"
			:poster="videoPoster || undefined"
			autoplay
			muted
			loop
			playsinline
			preload="metadata"
			aria-label="智慧课堂宣传视频"
		></video>
		<el-carousel v-else :height="lbHeight + 'px'">
			<el-carousel-item v-for="(item, index) in imgArr" :key="index">
				<img :src="$imgUrl + item.bannerImg" class="bgimgs" width="860" :height="lbHeight" alt="" />
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
export default {
	name: 'lunBo',
	data() {
		return {};
	},
	props: {
		lbHeight: {
			default: '',
			type: String
		},
		imgArr: {
			default: () => [],
			type: Array
		},
		videoSrc: {
			default: '',
			type: String
		},
		videoPoster: {
			default: '',
			type: String
		}
	},
	methods: {},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.lunbo-wrap {
	height: 100%;
}

.bgimgs {
	width: 100%;
	height: 100%;
	border-radius: 6px;
	object-fit: cover;
}

.bgvideo {
	display: block;
	width: 100%;
	height: 100%;
	border-radius: 6px;
	object-fit: cover;
	background: #061629;
}
</style>
